import React from 'react';
import { Route } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';

import MarketingPage from '../pages/MarketingPage';
import AuctionPage from '../pages/AuctionPage';
import AdminPage from '../pages/AdminPage';
import MyTeamsPage from '../pages/MyTeamsPage';

// To change a route from anywhere:
// import { push } from 'react-router-redux';
// store.dispatch(push('/foo'));

const Routes = ({ history }) => (
  <ConnectedRouter history={history}>
    <div>
      <Route exact path="/" component={MarketingPage} />
      <Route path="/new-cards" component={AuctionPage} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/your-cards" component={MyTeamsPage} />
    </div>
  </ConnectedRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/util/Routes.js